import { Form, Input, Select, Switch, Row, Col } from 'antd';
import { useSearchParams } from 'react-router-dom';

import './style.scss';

const { Option } = Select;

const TestEnvPanel = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const onScriptChange = (e) => {
    searchParams.set('version', e);
    setSearchParams(searchParams);
    window.location.reload();
  };

  const onTokenChange = ({ target }) => {
    searchParams.set('token', target.value);
    setSearchParams(searchParams);
  };

  return (
    <div className="test-env-accordion">
      <Form.Item label="Token" name="token">
        <Input
          size="large"
          placeholder="Enter your token"
          onChange={onTokenChange}
        />
      </Form.Item>
      <Form.Item label="JS/CSS Version" name="version">
        <Select
          size="large"
          placeholder="Select JS/CSS Version"
          onChange={onScriptChange}
        >
          <Option value="sdk/2.*">2.* (prod)</Option>
          <Option value="e2e">e2e</Option>
          <Option value="v2-beta">beta</Option>
          <Option value="latest">latest</Option>
          <Option value="sdk/2.17.0">2.17.0</Option>
          <Option value="sdk/2.16.*">2.16.*</Option>
          <Option value="sdk/2.16.0">2.16.0</Option>
          <Option value="sdk/2.14.0">2.14.0</Option>
          <Option value="sdk/2.14.*">2.14.*</Option>
          <Option value="sdk/2.13.1">2.13.1</Option>
          <Option value="sdk/2.13.0">2.13.0</Option>
          <Option value="sdk/2.13.*">2.13.*</Option>
        </Select>
      </Form.Item>
      <Form.Item label="API Version" name="env">
        <Select size="large" placeholder="Select API Version">
          <Option value="prod">prod</Option>
          <Option value="qa">qa</Option>
          <Option value="blue">blue</Option>
        </Select>
      </Form.Item>
      <Row justify="space-between">
        <Col span={18}>
          <h6>Enable Product Fallback</h6>
        </Col>
        <Col>
          <Form.Item name="isProductFallbackEnabled" valuePropName="checked">
            <Switch />
          </Form.Item>
        </Col>
      </Row>
      <Row justify="space-between">
        <Col span={12}>
          <h6>Use Cart Sync</h6>
        </Col>
        <Col>
          <Form.Item name="isProductCartEnabled" valuePropName="checked">
            <Switch />
          </Form.Item>
        </Col>
      </Row>

      {/* <Divider /> */}
      {/* <h6>Product Hydration</h6>
      <Form.Item label="Product" name="products">
        <Input.TextArea
          disabled
          size="large"
          rows={3}
          placeholder="Product Preview"
        />
      </Form.Item>
      <Form.Item label="Hydration Input" name="product_hydration">
        <Input.TextArea
          size="large"
          rows={3}
          placeholder="Enter hydration input"
        />
      </Form.Item> */}
    </div>
  );
};

export default TestEnvPanel;
